import { render, staticRenderFns } from "./Telegraphicdelivery.vue?vue&type=template&id=14b89a60&scoped=true&"
import script from "./Telegraphicdelivery.vue?vue&type=script&lang=js&"
export * from "./Telegraphicdelivery.vue?vue&type=script&lang=js&"
import style0 from "./Telegraphicdelivery.vue?vue&type=style&index=0&id=14b89a60&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b89a60",
  null
  
)

export default component.exports